import Vue from 'vue';

import { ssoStatestore as store } from 'v-store/ssoStatestore';	// 'store' för jag vet inte om/hur jag kan använda ett annat namn nedan :(
import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';
import euiPanelyta from 'v-components/euiPanelyta';

import { ssoTooltips } from 'ssoTooltips';

import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';
//import euiMermeny from 'v-components/euiMermeny';

//import euiFlikgruppClasses from 'v-components/classes/euiFlikgruppClasses';
//import euiFlikgrupp from 'v-components/euiFlikgrupp';


//import euiDialogClasses from 'v-components/classes/euiDialogClasses';
//import euiDialog from 'v-components/euiDialog';
//import euiMeddelandedialog from 'v-components/euiMeddelandedialog';
//import euiFormTextruta from 'v-components/euiFormTextruta.vue';

//import axios from 'axios';
//import objectToFormData from 'object-to-formdata';

//import { Resultat } from 'classes/ResultatClasses';

//import VeeValidateSsoDashboardNamnUnikt from 'VeeValidateSsoDashboardNamnUnikt';
//import VeeValidateRemote from 'VeeValidateRemote';
//VeeValidateSsoDashboardNamnUnikt.runOnce();	// Kör funktionen om den inte redan körts!
//VeeValidateRemote.runOnce();	// Kör funktionen om den inte redan körts!



window.ssoDiagramsidaRapport = window.ssoDiagramsidaRapport || {};	// För att undvika ESLint-varningar att den är odefinierad.

// Fixa till alla (ev) menyConfig objekt i window.ssoDiagramsidaRapport.widgets, så de är av rätt class type:
for (let i = 0; i < window.ssoDiagramsidaRapport.widgets.length; i++)
{
	if (window.ssoDiagramsidaRapport.widgets[i].menyConfig)
	{
		window.ssoDiagramsidaRapport.widgets[i].menyConfig =
			euiPopUpMenyClasses.menyConfig.castFrom(window.ssoDiagramsidaRapport.widgets[i].menyConfig, { castAlsoNestedObjectsAndArrayValues: true });		// "casta" till rätt typ, inkl alla nästade underobjekt/arrayvärden.
	}
}

//##############################################################################################################################

//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	store,	// ssoStatestore

	// Lokalt registrerade komponenter
	components: {
		euiPanelyta,
		//euiMermeny,
		//euiDialog,
		//euiMeddelandedialog,
		//euiFormTextruta,
		//euiFlikgrupp,
	},

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Data utöver de från mixin ovan:
	data: {
		widgets: window.ssoDiagramsidaRapport.widgets,		// Obs! Denna är tillfixad FÖRE Vue-appen initieras (räcker inte i beforeCreate!)
		//pageId: window.ssoDiagramsidaRapport.pageId,
	},


	//== Lifecycle hooks  ================================================================================================================ 

	beforeCreate() {
		// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.

		// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
		// Dessa används för att styra funktionalitet i mixin "ssoAllaSidorMixin":
		// Defaultvärde sätts numera i mixinen: this.$_rullningsbaraElementQuerySelectorAll = '.-rullningsbar-auto, .-rullningsbar-overlay, .-rullningsbar-auto-persist, .-rullningsbar-overlay-persist';
		this.$_vuexNamespace = 'diagramsidaRapport';
	},
});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;

